import React, { useState } from "react";
import {
  Modal,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { CrmMainService } from "../../../../service/manage/crm/crm_main.service";
import { sweetStatusAlert } from "../../../../components/common/SweetAlert";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  zIndex: 1300,
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1400,
};

const CrmDeleteSearchModel = ({
  isOpen,
  onClose,
  onOpen,
  state,
  selectedFilters,
  fetchSavedFilters,
  resetFilters,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteSaveFilter = async () => {
    try {
      setLoading(true);

      const filterObject = {
        node_mid: -1,
        search_id: selectedFilters[0]?.id,
        search_array: [],
        user_id: null,
        user_table_id: null,
        create_user_id: null,
        create_user_table_id: null,
        search_title: null,
        note: null,
      };

      onClose();
      const response = await CrmMainService.crm_search_criteria(filterObject);

      if (response.success) {
        sweetStatusAlert("Success", "Filter deleted successfully!", "success");
        await fetchSavedFilters();
        resetFilters();
      } else {
        onOpen();
        sweetStatusAlert(
          "Failed",
          "Failed to delete filter. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error deleting filter:", error);
      sweetStatusAlert(
        "Failed",
        "An error occurred while deleting the filter.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <Box sx={modalStyle}>
          <Typography variant="h6">Delete Saved Filter</Typography>
          <Typography variant="body1" mt={2}>
            Are you sure you want to delete the saved filter "
            {selectedFilters[0]?.title_text}"?
          </Typography>
          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button variant="outlined" color="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
               color="error"
              onClick={handleDeleteSaveFilter}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {loading && (
        <Box sx={overlayStyle}>
          <CircularProgress size={60} color="primary" />
        </Box>
      )}
    </>
  );
};

export default CrmDeleteSearchModel;
